<template>
  <div class="TemplateLight" v-if="baseData" :style="{backgroundImage: `url(${baseData.bg_pic ? baseData.bg_pic : bg})`}">
    <!-- 随机愿望 -->
    <div class="bg-light" @click="getRandomWish" v-if="topWishData">
      <div class="light light-left-top" @click.stop="checkWish(0)" v-if="topWishData[0]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
      <div class="light light-left-mid" @click.stop="checkWish(1)" v-if="topWishData[1]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
      <div class="light light-left-bottom" @click.stop="checkWish(2)" v-if="topWishData[2]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
      <div class="light light-right-top" @click.stop="checkWish(3)" v-if="topWishData[3]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
      <div class="light light-right-mid" @click.stop="checkWish(4)" v-if="topWishData[4]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
      <div class="light light-right-bottom" @click.stop="checkWish(5)" v-if="topWishData[5]">
        <img class="lightBlink" :src="imgList[0]" alt="">
      </div>
    </div>
    <!-- 操作区域 -->
    <div class="actionArea" v-show="!flashDisplay">
      <div class="btn btn-wish" @click="wishClick">{{baseData.button_text}}</div>
      <div class="btn btn-message" @click="messageClick">
        <i class="iconfont icon-wode"></i>
      </div>
    </div>
    <!-- :height="clientHeight" -->
    <!-- 留言填写层 -->
    <div class="messageLayer" :style="{height: `${clientHeight}px`}" v-if="messageDisplay">
      <div class="messageTextarea">
        <textarea class="textarea" v-model="messageValue" placeholder="请填写留言（4 - 500字为宜）"></textarea>
        <!-- 字数显示 -->
        <div class="wordCount">
          {{messageValue.length}} / 500
        </div>
      </div>
      <!-- 留言提交按钮 -->
      <div class="btnArea">
        <div class="btn btn-sending wishwall-comment"
          :class="{active: messageValue.length > 3}"
          @click="sendAction">发 送</div>
        <div class="btn btn-cancel" @click="sendingCancel">取 消</div>
      </div>
    </div>
    <!-- 留言动画 -->
    <div class="messageFlash" v-if="flashDisplay">
      <div class="layer">
        <div class="textbox">
          {{messageValue}}
        </div>
      </div>
    </div>
    <!-- 留言展示 -->
    <div class="messageShow" v-if="messageShowDisplay && currentWish" @click.stop>
      <div class="avatar" :style="{backgroundImage: `url(${currentWish.avatar_url})`}"></div>
      <div class="content">{{currentWish.content}}</div>
      <div class="footer">
        <div class="footer-left">
          <div class="nickname">{{currentWish.nickname}}</div>
          <div class="time">{{currentWish.created_at}}</div>
        </div>
        <div class="footer-right wishwall-like" :class="{active: currentWish.is_favor}" @click="zan" v-if="baseData.enable_favor === 1">
          <i class="iconfont icon-dianzan"></i>
          <span>{{currentWish.favor_count}}</span>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <div class="closeBtn" @click="messageShowDisplay = false">
        <i class="iconfont icon-guanbi"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getSticky, getWish, getChangeisfavor, getPushwish } from 'api'
import { resetScrollTop, getDate } from '../assets/js/tool'

export default {
  name: 'TemplateLight',
  props: {
    baseData: {
      type: Object
    },
    query: {
      type: Object
    },
    itemStatus: {
      type: Number
    },
    rightClass: {
      type: Boolean
    },
    logout: {
      type: Boolean
    },
    needFocus: {
      type: Boolean
    },
    exceptionUA: {
      type: Object
    },
  },
  data() {
    return {
      imgList: [
        require('../assets/img/light-shape.png'),
        require('../assets/img/sending-disabled.png'),
        require('../assets/img/sending.png'),
        require('../assets/img/sending-active.png'),
        require('../assets/img/zan.png'),
        require('../assets/img/zan-active.png')
      ],
      bg: require('../assets/img/light-bg.jpg'), // 默认图片
      wordCount: 0,
      messageValue: '',
      messageDisplay: false, // 许愿页面
      flashDisplay: false, // 许愿动画飞出显示
      messageShowDisplay: false, // 许愿展示页面
      topWishData: null, // 置顶愿望数据
      currentWish: null, // 当前查看的愿望数据
      messageList: [
        '当前为预览模式！',
        '活动未开始',
        '活动已结束',
        '您不在活动的用户组中，没有参与活动的权限'
      ]
    }
  },
  watch: {
    messageValue(val) {
      if (val && val.length > 500) {
        this.messageValue = val.substring(0, 500)
      }
    }
  },
  computed: {
    isPreview() {
      return this.query.preview
    },
    params() {
      return Object.assign({}, this.query)
    },
  },
  created() {
    this.clientHeight = document.body.clientHeight
    getSticky(this.params).then(res => {
      if (res.code === 3001) {
        this.topWishData = res.data.list
      }
    })
  },
  mounted() {
    // 非正常活动情况检验
    this.previewAlert()
  },
  methods: {
    previewAlert() {
      if (this.isPreview || this.itemStatus !== 0 || !this.rightClass) {
        let message
        if (!this.rightClass) {
          message = this.messageList[3]
        } else {
          message = this.isPreview ? '当前为预览模式！' : this.messageList[this.itemStatus]
        }
        this.$toast(message)
        return true
      }
    },
    logoutAlert() {
      if (this.logout) {
        let vm = this
        // 调用登陆接口
        CP.show_login(function(data) {
          // 表示当前登录状态为未登录的状态
          if (data.is_login === '1') {
            vm.$emit('update:logout', false)
            vm.$emit('login', data)
          }
        })
        return true
      }
    },
    exceptionUAAlert() {
      if (this.exceptionUA) {
        // 提示微信扫描二维码进入活动，反之前往客户端
        if (this.exceptionUA.need_qrcode) {
          this.$router.push({name: 'wxScan'})
        } else {
          this.exceptionUA.download_url && (window.location.href = this.exceptionUA.download_url)
        }
        return true
      }
    },
    messageClick() {
      if (this.exceptionUAAlert()) return
      // 预览模式和非期组别不允许进入
      if (this.isPreview || !this.rightClass) {
        const message = this.isPreview ? '当前为预览模式！' : '您不在活动的用户组中，没有参与活动的权限'
        this.$toast(message)
        return
      }
      if (this.logoutAlert()) return
      this.$router.push({name: 'message', query: {...this.query}})
    },
    wishClick() {
      // 重置留言框状态，避免两者重叠的情况
      if (this.messageShowDisplay) {
        this.messageShowDisplay = false
      }
      if (this.exceptionUAAlert()) return
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      this.messageDisplay = true
    },
    getRandomWish() {
      if (this.messageShowDisplay) return
      if (this.wishFlag) return
      this.wishFlag = true
      getWish(this.params).then(res => {
        if (res.code === 3001) {
          this.currentWish = res.data.list[0]
          this.messageShowDisplay = true
        } else {
          alert(res.msg)
        }
        this.wishFlag = false
      })
    },
    checkWish(index) {
      this.currentWish = this.topWishData[index]
      this.messageShowDisplay = true
    },
    zan() {
      if (this.exceptionUAAlert()) return
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      // 模拟数据
      if (this.zanflag) return
      this.zanflag = true
      this.params.wish_id = this.currentWish.wish_id
      getChangeisfavor(this.params).then(res => {
        if (res.code === 3001) {
          if (this.currentWish.is_favor) {
            this.currentWish.favor_count -= 1
          } else {
            this.currentWish.favor_count += 1
          }
          this.$set(this.currentWish, 'is_favor', !this.currentWish.is_favor)
        } else if (res.code === 5011) {
          this.$emit('update:needFocus', true)
        }else {
          this.$toast(res.msg)
        }
        this.zanflag = false
      })
    },
    sendAction() {
      if (this.messageValue.length > 3) {
        if (this.flag) return
        this.flag = true
        const formData = new FormData();
        formData.append('content', this.messageValue)
        getPushwish('/activity/api.php?m=front&subm=wishwall&action=pushwish', this.params, formData)
          .then(res => {
            // 3001,处理动画，重置变量
            if (res.code === 3001) {
              this.handleSending()
            } else if (res.code === 5011) {
              this.$emit('update:needFocus', true)
            }else {
              this.$toast(res.msg)
            }
            this.flag = false
          }).catch(() => {
            this.flag = false
            this.$toast('异常错误')
          })
      } else if (this.messageValue.length === 0) {
        this.$toast('请填写你的留言！')
      }
      // 重置微信6.7.4版本之后，关闭输入法页面为还原的问题
      resetScrollTop()
    },
    sendingCancel() {
      this.messageValue = ''
      this.messageDisplay = false
    },
    handleSending() {
      // 关闭留言层
      this.messageDisplay = false
      // 显示动画层
      this.flashDisplay = true
      // 清除定时器，延时显示操作按钮
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.baseData.prompt_text ?
          this.$message({
            message: this.baseData.prompt_text,
            url: this.baseData.redirect_url
          }) :
          this.$message({message: '恭喜！我们已收到您的消息，审核通过后可展示在活动首页，敬请关注。'})

        // 重置操作区域，重置前面填写的信息
        this.flashDisplay = false
        this.messageValue = ''
      }, 1500)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="stylus" scoped>
@import "~assets/css/mixin"

.TemplateLight
  min-height: 100vh
  // background: url('../assets/img/light-bg.jpg')
  background-size: 100% 100%
  position: relative
  .bg-light
    // height: 4.6rem
    height: 76vh
    background: url('../assets/img/light-bg.png')
    background-size: 100% 100%
    position: relative
    .light
      position: absolute
      width: 1.24rem
      height: 1.24rem
      // border: 1px solid red
      background: url('../assets/img/light-self.png')
      background-size: 100% 100%
      .lightBlink
        animation: blink 2s infinite
        @keyframes blink {
          0% {opacity: 1}
          50% {opacity: 0}
          100% {opacity: 1}
        }
      & > img
        width: 100%
        height: 100%
    .light-left-top
      left: 1.3rem
      top: 0.38rem
      width: 0.5rem
      height: 0.5rem
      transform: rotateZ(-10deg)
      animation: shake1 2s ease-in-out infinite
      @keyframes shake1 {
        0%, 50% {transform: rotateZ(-10deg)}
        60% {transform: rotateZ(0deg)}
        70% {transform: rotateZ(-20deg)}
        80% {transform: rotateZ(0deg)}
        90% {transform: rotateZ(-20deg)}
        100% {transform: rotateZ(-10deg)}
      }
    .light-left-mid
      left: 0.6rem
      top: 1.2rem
      animation: shake2 2s ease-in-out 0.5s infinite
      @keyframes shake2 {
        0%, 50% {transform: rotateZ(0deg)}
        60% {transform: rotateZ(10deg)}
        70% {transform: rotateZ(-10deg)}
        80% {transform: rotateZ(10deg)}
        90% {transform: rotateZ(-10deg)}
        100% {transform: rotateZ(0deg)}
      }
    .light-left-bottom
      left: 0.7rem
      bottom: 0.7rem
      width: 0.6rem
      height: 0.6rem
      transform: rotateZ(-8deg)
      animation: shake3 2s ease-in-out 1s infinite
      @keyframes shake3 {
        0%, 50% {transform: rotateZ(-8deg)}
        60% {transform: rotateZ(2deg)}
        70% {transform: rotateZ(-18deg)}
        80% {transform: rotateZ(2deg)}
        90% {transform: rotateZ(-18deg)}
        100% {transform: rotateZ(-8deg)}
      }
    .light-right-top
      top: 0.35rem
      right: 0.54rem
      width: 0.7rem
      height: 0.7rem
      transform: rotateZ(10deg)
      animation: shake4 2s ease-in-out 1.5s infinite
      @keyframes shake4 {
        0%, 50% {transform: rotateZ(10deg)}
        60% {transform: rotateZ(20deg)}
        70% {transform: rotateZ(0deg)}
        80% {transform: rotateZ(20deg)}
        90% {transform: rotateZ(0deg)}
        100% {transform: rotateZ(10deg)}
      }
    .light-right-mid
      top: 1.64rem
      right: 0.4rem
      width: 0.56rem
      height: 0.56rem
      transform: rotateZ(6deg)
      animation: shake5 2s ease-in-out 2s infinite
      @keyframes shake5 {
        0%, 50% {transform: rotateZ(6deg)}
        60% {transform: rotateZ(16deg)}
        70% {transform: rotateZ(-4deg)}
        80% {transform: rotateZ(16deg)}
        90% {transform: rotateZ(-4deg)}
        100% {transform: rotateZ(6deg)}
      }
    .light-right-bottom
      top: 2.4rem
      right: 0.94rem
      width: 0.7rem
      height: 0.7rem
      animation: shake6 2s ease-in-out 2.5s infinite
      @keyframes shake6 {
        0%, 50% {transform: rotateZ(0deg)}
        60% {transform: rotateZ(10deg)}
        70% {transform: rotateZ(-10deg)}
        80% {transform: rotateZ(10deg)}
        90% {transform: rotateZ(-10deg)}
        100% {transform: rotateZ(0deg)}
      }
  .actionArea
    position: absolute
    // bottom: 0.4rem
    // bottom: 6.6vh
    bottom: 4vh
    width: 100%
    display: flex
    justify-content: space-around
    .btn
      line-height: 0.4rem
      border-radius: 0.2rem
      text-align: center
    .btn-wish
      min-width: 2rem
      height: 0.4rem
      padding: 0 0.1rem
      background-color: #ec4d5e
      background-color: var(--color)
      font-size: 0.2rem
      // font-family: "SimSun"
      font-weight: bold
      color: #fff
    .btn-message
      width: 0.75rem
      height: 0.4rem
      color: #ec4d5e
      color: var(--color)
      background-color: #fee6ce
      .iconfont
        font-size: 0.24rem
  .messageLayer
    position: absolute
    top: 0
    left: 0
    // right: 0
    // bottom: 0
    width: 100vw
    // height: 100vh
    background: url('../assets/img/letter.jpg')
    background-size: 100% 100%
    overflow: scroll
    .messageTextarea
      margin: 0.8rem auto 0.2rem
      width: 90%
      height: 64%
      border: 1px solid #ccc
      position: relative
      .textarea
        box-sizing: border-box
        padding: 0.1rem
        width: 100%
        height: 92%
        border: none
        outline: none
        background: transparent
        -webkit-overflow-scrolling: touch
      .wordCount
        position: absolute
        right: 0.1rem
        bottom: 0.08rem
        color: #a0a0a0
    .btnArea
      color: #fff
      display: flex
      justify-content: center
      .btn
        width: 1.28rem
        height: 0.36rem
        line-height: 0.36rem
        border-radius: 0.18rem
        font-weight: bold;
        text-align: center
      .btn-sending
        background-color: #a0a0a0
        transition: background-image 0.5s
        &.active
          background-color: #ec4d5e
          background-color: var(--color)
      .btn-cancel
        margin-left: 0.1rem
        background-color: #f1b151
  .messageFlash
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    perspective: 1200px
    .layer
      position: absolute
      transform-style: preserve-3d
      top: 1.2rem
      left: calc((100vw - 2.42rem) / 2)
      width: 2.42rem
      height: 3.88rem
      background: url('../assets/img/letter.jpg')
      background-size: 100% 100%
      animation: move 1.2s ease forwards
      @keyframes move {
        0% {
          opacity: 1
          transform: translateZ(0)
        }
        50% {
          opacity: 0.8
          transform: translate3d(0, 0, -800px)
        }
        100% {
          opacity: 0.8
          transform: translate3d(0, -1000px , -1200px)
        }
      }
      .textbox
        margin: 22% auto 0
        width: 90%
        height: 64%
        overflow: hidden
  .messageShow
    position: absolute
    top: 6%
    left: 50%
    transform: translate3d(-50%, 0, 0)
    width: 80%
    height: 76vh
    background: url('../assets/img/letter.jpg')
    background-size: 100% 100%
    display: flex
    flex-direction: column
    align-items: center
    animation: action 0.4s
    @keyframes action {
      from {opacity: 0}
      to {opacity: 1}
    }
    .avatar
      margin: 0.12rem 0 0.26rem
      width: 0.52rem
      height: 0.52rem
      border-radius: 50%
      background-color: orange
      background-size: 100% 100%
    .content
      flex: 1
      width: 85%
      line-height: 0.28rem;
      overflow-y: scroll
      font-size: 0.16rem;
      -webkit-overflow-scrolling:touch
      white-space: pre-wrap;
    .footer
      margin: 0.2rem 0 0.24rem
      width: 64%
      height: 0.4rem
      font-size: 0.12rem
      display: flex
      justify-content: space-between
      align-items: center
      .footer-left
        .nickname
          margin-bottom: 0.08rem
          font-weight: bold
      .footer-right
        &.active
          color: #ec4d5e
          color: var(--color)
        .iconfont
          margin-right: 0.06rem
    .closeBtn
      position: absolute
      top: -0.14rem
      right: -0.14rem
      width: 0.3rem
      height: 0.3rem
      border-radius: 50%
      background-color: #ec4d5e
      background-color: var(--color)
      color: #fff
      flexCenter()
</style>


